import { Directive } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EventService } from './service/event.service';


@Directive()
export class BaseComponent {
    sub : Subscription ;
   
    constructor(private readonly baseEventBus: EventService, private readonly baseRouter: Router) {
    }

    closeWindow() {
        let win = window.open("", "_self"); 
        win.close();
      }

}